import { render, staticRenderFns } from "./ImageContainer.vue?vue&type=template&id=4048a7b4&scoped=true&"
import script from "./ImageContainer.vue?vue&type=script&lang=ts&"
export * from "./ImageContainer.vue?vue&type=script&lang=ts&"
import style0 from "./ImageContainer.vue?vue&type=style&index=0&id=4048a7b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4048a7b4",
  null
  
)

export default component.exports